  const reviewMainElements = document.querySelectorAll('#judgeme_product_reviews');

  // Configuration of the MutationObserver
  const config = { attributes: true, childList: true, subtree: true };

  // Callback function to execute when mutations are observed
  const callback = function (mutationsList, observer) {
    const isMeathearts = document.body.classList.contains('product-details-meathearts');
    const meatheartsVersionMap = {
      2025: 'Meathearts™ Version 6.0',
      2024: 'Meathearts™ Version 5.0',
      2023: 'Meathearts™ Version 4.0',
      2022: 'Meathearts™ Version 3.0',
      2021: 'Meathearts™ Version 2.0',
      2020: 'Meathearts™ Version 1.0'
    }

    for (const mutation of mutationsList) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        if (isMeathearts) {
          document.querySelectorAll('.jdgm-rev').forEach(function (review) {
            if (review.querySelector('.review-version')) return;
    
            const list = review.querySelector('.jdgm-rev__body');
            const timestamp = review.querySelector('.jdgm-rev__timestamp');
            if (!list) return; // Skip if list is not found
            if (!timestamp) return;
    
            const newNode = document.createElement("div");
            newNode.className = "review-version";
    
            const reviewYear = timestamp.textContent.split('/')[2];
            let versionText = "";
    
            if(meatheartsVersionMap[reviewYear]) {
              versionText = `<b style="font-family:sans-serif;">Purchased item:</b> <k>${meatheartsVersionMap[reviewYear]}</k>`;
              newNode.innerHTML = versionText; // Set content
              list.appendChild(newNode); // Insert node at the end
            }
          });
        }
      }
    }
  };

    reviewMainElements.forEach((targetNode) => {
      const reviewsobserver = new MutationObserver(callback);
      reviewsobserver.observe(targetNode, config);
    });


  



// For Product Addon

document.addEventListener('DOMContentLoaded', function () {
    //Checks if upsell is checked or not
      var checkedCheckboxes = [];
      var checkboxes = document.querySelectorAll('.addon-checkbox');
      var form = document.querySelector('.shopify-product-form');
      var mainProductVariantIdElement = document.querySelector('.main-product-variant-id');
    
      checkboxes.forEach(function (checkbox) {
        checkbox.addEventListener('change', function () {
          if (this.checked) {
            this.setAttribute('selected', 'selected');
            var variant_Id = this.closest('.add-on-product').getAttribute('variant-id');
            var variantId = Number(variant_Id);
            checkedCheckboxes.push(variantId);
          } else {
            this.removeAttribute('selected');
            var variant_Id = this.closest('.add-on-product').getAttribute('variant-id');
            var variantId = Number(variant_Id);
            checkedCheckboxes = checkedCheckboxes.filter(id => id !== variantId);
          }
    
          // Update the hidden input elements in the form
          updateHiddenInputs();
        });
      });
      
      //appends input with varaint id inside form
      function updateHiddenInputs() {
        // Remove existing hidden inputs
        form.querySelectorAll('input[name^="items["]').forEach(function (input) {
          input.remove();
        });
    
        // Add hidden inputs for each checked checkbox just below .main-product-variant-id
        checkedCheckboxes.forEach(function (variantId) {
          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = `items[${variantId}][id]`;
          input.value = variantId;
          form.insertBefore(input, mainProductVariantIdElement.nextSibling);
        });
    
      }
 
      //popup on click of more details  
      window.togglePopup = function(variantId) {
        var popupTemplate = document.getElementById('popup-template-' + variantId);
        var body = document.querySelector('body');
        
        if (popupTemplate) {
          if (popupTemplate.style.display === 'none' || popupTemplate.style.display === '') {
            popupTemplate.style.display = 'grid';
            body.classList.add('popup-overflow-hidden');  
          } else {
            popupTemplate.style.display = 'none';
            body.classList.remove('popup-overflow-hidden'); 
          }
        }
      }

      window.closePopupOutside = function(event, variantId) {
        var popupTemplate = document.getElementById('popup-template-' + variantId);
        var body = document.querySelector('body');
      
        if (event.target.id === 'popup-template-' + variantId)  {
          if (popupTemplate.style.display === 'grid') {
            popupTemplate.style.display = 'none';
            body.classList.remove('popup-overflow-hidden');
          }
        }
      }

    });

    if(document.querySelector('body.shipping.page-shipping.template-page [title="Email newsletter sign-up web form"]')){
      document.querySelector('body.shipping.page-shipping.template-page [title="Email newsletter sign-up web form"]').addEventListener('click',function(){
        document.querySelector('body.shipping.page-shipping.template-page section#email').style.display="block";  
      })
    }


    document.addEventListener('AppstleSubscription:SubscriptionWidget:SellingPlanSelected', function() {
      if(document.querySelector('.custom_appstle_hide_old_price')){
        document.querySelector('.custom_appstle_hide_old_price').style.display="none";
      }
      setTimeout(function(){
        if(document.querySelector('.modal_price .appstle_subscription_final_price')){
          document.querySelector('.modal_price  [data-price-ui]').classList.add("apstle_subscription_old_price");
        }
      },100)
    });
    
    document.addEventListener('AppstleSubscription:SubscriptionWidget:SellingPlanRemoved', function() {
      if(document.querySelector('.custom_appstle_hide_old_price')){
        document.querySelector('.custom_appstle_hide_old_price').style.display="unset"
      }
      if(document.querySelector('.apstle_subscription_old_price')){
        document.querySelector('.modal_price  [data-price-ui]').classList.remove("apstle_subscription_old_price");
      }
    });
  
    // document.body.addEventListener('click', function(event) {
    //   // Check if the clicked element is a <k> inside a .review-version
    //   if (event.target && event.target.matches('.review-version k')) {
    //     event.preventDefault(); // Prevent default action
        
    //     const isMobile = window.innerWidth <= 768; // Check if the device is mobile (you can adjust this value as needed)
    //     const url =  window.PXUTheme.theme_settings.review_url;

    //     if (isMobile) {
    //         // Open in the same tab on mobile
    //         window.location.href = url;
    //     } else {
    //         // Open in a new tab on desktop
    //         window.open(url, '_blank');
    //     }
    //   }
    // });


  document.querySelector('body').addEventListener('click', function (event) {
    if (event.target.matches('.review-version k')) {
        event.preventDefault()
        document.querySelector('div#Version-Modal').style.display = 'block';
        document.querySelector('.version-page').scrollTop = 10;
        document.querySelector('html').style.overflow = 'hidden';
    }
  });
  
  document.querySelector('body').addEventListener('click', function (event) {
      if (event.target.matches('.version-modal-content .closes')) {
          document.querySelector('div#Version-Modal').style.display = 'none';
          document.querySelector('html').style.overflow = 'visible';
      }
      if (event.target.matches('.version-modal-content .closes span')) {
        document.querySelector('div#Version-Modal').style.display = 'none';
        document.querySelector('html').style.overflow = 'visible';
      }
  });

  window.onclick = function(event) {
    if (event.target == document.querySelector('div#Version-Modal')) {
      document.querySelector('div#Version-Modal').style.display = "none";
      document.querySelector('html').style.overflow = 'visible';
    }
  }

  (function () {
    const hiddenClass = 'meathearts-size-option-hidden';
    const sizeOnlyClass = 'meathearts-snack-tray-size-only';
    const observedOptionsSelections = new WeakSet();
    let initialized = false;
    let bootAttempts = 0;

    function getMeatheartsRoot() {
      return document.querySelector('.product_section_ecom .variant-selection[product-url*="meathearts"]') ||
        document.querySelector('.product_section_ecom .product_form');
    }

    function isMeatheartsPage() {
      const productSelection = document.querySelector('.product_section_ecom .variant-selection[product-url*="meathearts"]');
      const hasMeatheartsProductClass =
        document.body.className.indexOf('product-') !== -1 &&
        document.body.className.indexOf('meathearts') !== -1;

      return Boolean(productSelection || (hasMeatheartsProductClass && document.querySelector('.product_section_ecom')));
    }

    function couldBeMeatheartsPage() {
      return document.body.className.indexOf('meathearts') !== -1 ||
        window.location.pathname.toLowerCase().indexOf('meathearts') !== -1;
    }

    function normalize(value) {
      return String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
    }

    function compact(value) {
      return normalize(value).replace(/\s+/g, '');
    }

    function getOptionFieldset(optionName) {
      const root = getMeatheartsRoot();
      if (!root) return null;

      const fieldsets = root.querySelectorAll('[data-option-original="true"][data-option-heading]');

      return Array.prototype.find.call(fieldsets, function (fieldset) {
        return normalize(fieldset.dataset.optionHeading) === normalize(optionName);
      });
    }

    function getOptionWrapper(fieldset, optionValue) {
      if (!fieldset) return null;

      const expectedValue = compact(optionValue);
      const wrappers = fieldset.querySelectorAll('[data-variant-option-value-wrapper]');

      return Array.prototype.find.call(wrappers, function (wrapper) {
        return compact(wrapper.dataset.originalOptionValue) === expectedValue;
      });
    }

    function getCheckedValue(fieldset) {
      const checkedInput = fieldset && fieldset.querySelector('[data-variant-option-value]:checked');

      return checkedInput ? checkedInput.value : '';
    }

    function selectOption(wrapper) {
      const input = wrapper && wrapper.querySelector('[data-variant-option-value]');

      if (!input || input.checked) return;

      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function syncMeatheartsSnackTraySize() {
      if (!isMeatheartsPage()) return;

      const packagingFieldset = getOptionFieldset('Packaging');
      const sizeFieldset = getOptionFieldset('Size');
      const size46Wrapper = getOptionWrapper(sizeFieldset, '4.6 OZ');
      const size23Wrapper = getOptionWrapper(sizeFieldset, '2.3 OZ');

      if (!packagingFieldset || !sizeFieldset || !size46Wrapper || !size23Wrapper) return;

      const isSnackTraySelected = normalize(getCheckedValue(packagingFieldset)) === 'snack tray';
      const size46Input = size46Wrapper.querySelector('[data-variant-option-value]');

      if (isSnackTraySelected && size46Input && size46Input.checked) {
        selectOption(size23Wrapper);
      }

      sizeFieldset.classList.toggle(sizeOnlyClass, isSnackTraySelected);
      size46Wrapper.classList.toggle(hiddenClass, isSnackTraySelected);
      size46Wrapper.setAttribute('aria-hidden', isSnackTraySelected ? 'true' : 'false');
      if (size46Input) {
        size46Input.disabled = isSnackTraySelected;
        size46Input.tabIndex = isSnackTraySelected ? -1 : 0;
      }
    }

    function scheduleMeatheartsSnackTraySizeSync() {
      syncMeatheartsSnackTraySize();
      window.requestAnimationFrame(syncMeatheartsSnackTraySize);
      setTimeout(syncMeatheartsSnackTraySize, 80);
      setTimeout(syncMeatheartsSnackTraySize, 250);
    }

    function observeOptionSelections() {
      const root = getMeatheartsRoot();
      if (!root) return;

      root.querySelectorAll('options-selection').forEach(function (optionsSelection) {
        if (observedOptionsSelections.has(optionsSelection)) return;

        const observer = new MutationObserver(scheduleMeatheartsSnackTraySizeSync);
        observer.observe(optionsSelection, { attributes: true, childList: true, subtree: true });
        observedOptionsSelections.add(optionsSelection);
      });
    }

    function initMeatheartsSnackTraySizeGuard() {
      if (!isMeatheartsPage()) return;

      observeOptionSelections();
      scheduleMeatheartsSnackTraySizeSync();

      if (initialized) return;
      initialized = true;

      document.addEventListener('change', function (event) {
        if (
          event.target instanceof Element &&
          event.target.closest('.product_section_ecom') &&
          event.target.matches('[data-variant-option-value]')
        ) {
          scheduleMeatheartsSnackTraySizeSync();
        }
      });
    }

    function retryMeatheartsSnackTraySizeGuard() {
      initMeatheartsSnackTraySizeGuard();

      if (initialized || !couldBeMeatheartsPage() || bootAttempts >= 20) return;

      bootAttempts += 1;
      setTimeout(retryMeatheartsSnackTraySizeGuard, 250);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', retryMeatheartsSnackTraySizeGuard);
    } else {
      retryMeatheartsSnackTraySizeGuard();
    }

    document.addEventListener('shopify:section:load', initMeatheartsSnackTraySizeGuard);
  })();
  
  
